import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'

const capabilities = [
  { num: '01', title: 'Technology Leadership', desc: 'CTOs, VPs of Engineering, Site Heads, and Technical Fellows for GCCs and product companies.' },
  { num: '02', title: 'Data Science & AI', desc: 'Heads of Data Science, ML Architects, Chief Data Officers, and Principal Data Engineers.' },
  { num: '03', title: 'Product Leadership', desc: 'VPs of Product, Group Product Managers, and Directors shaping global product strategy and roadmaps.' },
  { num: '04', title: 'Platform & Infrastructure', desc: 'Cloud Architecture, DevOps Leadership, SRE Heads, and Platform Engineering Leads.' },
  { num: '05', title: 'Founding GCC Teams', desc: 'Full leadership cohort placement for centres standing up their global presence for the first time.' },
  { num: '06', title: 'Digital & Design', desc: 'Heads of UX, Design Directors, and Digital Transformation Leaders with global operating experience.' },
  { num: '07', title: 'Analytics & Insights', desc: 'Business Intelligence Heads, Analytics Engineering Leads, and Decision Science Directors.' },
  { num: '08', title: 'Security & Compliance', desc: 'CISOs, VP Security, and Heads of Risk and Compliance for regulated-industry GCCs.' },
]

export default function CapabilitiesSection() {
  return (
    <section
      data-testid="capabilities-section"
      id="capabilities"
      className="py-32 md:py-40 px-6 md:px-12 lg:px-24 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8"
        >
          <div>
            <p className="text-[10px] tracking-[0.35em] uppercase text-[#0A0A0A]/30 mb-5 font-body font-semibold">
              Where We Search
            </p>
            <h2 className="text-[clamp(2.5rem,5vw,5rem)] font-heading font-black tracking-tighter leading-none text-[#0A0A0A]">
              Capability<br />
              <span className="font-light text-[#16365F]">areas</span>
            </h2>
          </div>
        </motion.div>

        <div className="border-t border-[#E5E7EB]">
          {capabilities.map((cap, i) => (
            <motion.div
              key={cap.num}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group flex items-start gap-6 md:gap-12 py-7 border-b border-[#E5E7EB] cursor-default hover:bg-[#F6F7F9] transition-colors duration-200 px-2"
              data-testid={`capability-item-${i + 1}`}
            >
              <span className="text-[10px] font-body text-[#0A0A0A]/20 pt-1 w-6 flex-shrink-0 font-semibold tracking-widest">
                {cap.num}
              </span>
              <div className="flex-1 flex flex-col md:flex-row md:items-center gap-3 md:gap-10">
                <h3 className="text-base md:text-lg font-heading font-bold text-[#0A0A0A] leading-tight tracking-tight min-w-[200px]">
                  {cap.title}
                </h3>
                <p className="text-sm font-body text-[#0A0A0A]/45 leading-relaxed">
                  {cap.desc}
                </p>
              </div>
              <ArrowRight
                size={14}
                className="text-[#0A0A0A]/20 group-hover:text-[#16365F] transition-colors duration-200 flex-shrink-0 mt-1"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
